import React, { useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';


import './image.css';

export default function Image(props) {
	const [image, setImage] = useState(null);

	useEffect(() => {
	}, []);

	function openImage() {
		setImage(props.src);
	}

	function close() {
		setImage(null);
	}

	return (
		<>
			{image !== null &&
				<div className="enlarge-image text-vcenter">
					<img src={image} onClick={()=>close()} style={{cursor: 'pointer'}} />
					<div className="enlarge-image-close">
						<FontAwesomeIcon size="3x" icon="xmark" onClick={()=>close()} />
					</div>
				</div>
			}
			<img src={props.src} alt={props.alt} className={props.className} width={props.width} height={props.height} onClick={()=>openImage()} style={{cursor: 'pointer'}} />
		</>
	);
}
